export const white = 'var(--plasma-colors-white)';
export const whitePrimary = 'var(--plasma-colors-white-primary)';
export const whiteSecondary = 'var(--plasma-colors-white-secondary)';
export const whiteTertiary = 'var(--plasma-colors-white-tertiary)';

export const black = 'var(--plasma-colors-black)';
export const blackPrimary = 'var(--plasma-colors-black-primary)';
export const blackSecondary = 'var(--plasma-colors-black-secondary)';
export const blackTertiary = 'var(--plasma-colors-black-tertiary)';

export const dark01 = 'var(--plasma-colors-dark01)';
export const dark02 = 'var(--plasma-colors-dark02)';
export const dark03 = 'var(--plasma-colors-dark03)';

export const transparent = 'var(--plasma-colors-transparent)';
export const text = 'var(--plasma-colors-text)';

export const primary = 'var(--plasma-colors-primary)';
export const secondary = 'var(--plasma-colors-secondary)';
export const tertiary = 'var(--plasma-colors-tertiary)';

export const inverse = 'var(--plasma-colors-inverse)';
export const paragraph = 'var(--plasma-colors-paragraph)';

export const background = 'var(--plasma-colors-background)';
export const backgroundPrimary = 'var(--plasma-colors-background-primary)'; // ToDo: https://github.com/sberdevices/plasma/issues/1107
export const backgroundSecondary = 'var(--plasma-colors-background-secondary)'; // ToDo: https://github.com/sberdevices/plasma/issues/1107
export const backgroundTertiary = 'var(--plasma-colors-background-tertiary)'; // ToDo: https://github.com/sberdevices/plasma/issues/1107

export const success = 'var(--plasma-colors-success)';
export const warning = 'var(--plasma-colors-warning)';
export const critical = 'var(--plasma-colors-critical)';
export const overlay = 'var(--plasma-colors-overlay)';

export const surfaceLiquid01 = 'var(--plasma-colors-surface-liquid01)'; // ToDo: https://github.com/sberdevices/plasma/issues/1107
export const surfaceLiquid02 = 'var(--plasma-colors-surface-liquid02)'; // ToDo: https://github.com/sberdevices/plasma/issues/1107
export const surfaceLiquid03 = 'var(--plasma-colors-surface-liquid03)'; // ToDo: https://github.com/sberdevices/plasma/issues/1107
export const surfaceSolid01 = 'var(--plasma-colors-surface-solid01)';
export const surfaceSolid02 = 'var(--plasma-colors-surface-solid02)';
export const surfaceSolid03 = 'var(--plasma-colors-surface-solid03)';
export const surfaceCard = 'var(--plasma-colors-surface-card)';

export const buttonPrimary = 'var(--plasma-colors-button-primary)';
export const buttonSecondary = 'var(--plasma-colors-button-secondary)';
export const buttonSuccess = 'var(--plasma-colors-button-success)';
export const buttonWarning = 'var(--plasma-colors-button-warning)';
export const buttonCritical = 'var(--plasma-colors-button-critical)';
export const buttonChecked = 'var(--plasma-colors-button-checked)';

export const speechBubbleSent = 'var(--plasma-colors-speech-bubble-sent)';
export const speechBubbleReceived = 'var(--plasma-colors-speech-bubble-received)';

export const accent = 'var(--plasma-colors-accent)';
export const buttonAccent = 'var(--plasma-colors-button-accent)';
export const buttonFocused = 'var(--plasma-colors-button-focused)';
export const gradient = 'var(--plasma-colors-gradient)';
export const voicePhraseGradient = 'var(--plasma-colors-voice-phrase-gradient)';
export const skeletonGradient = 'var(--plasma-colors-skeleton-gradient)';
export const skeletonGradientLighter = 'var(--plasma-colors-skeleton-gradient-lighter)';
